export const RSI2_STRATEGY_ID = 'rsi2';
const LEGACY_RSI2_STRATEGY_LABEL = 'RSI(2) Connors';

export function normalizeStrategyId(strategy) {
  return strategy === LEGACY_RSI2_STRATEGY_LABEL ? RSI2_STRATEGY_ID : strategy;
}

export function strategyLabel(strategy) {
  return normalizeStrategyId(strategy) === RSI2_STRATEGY_ID
    ? LEGACY_RSI2_STRATEGY_LABEL
    : (strategy || 'Manual');
}